<p-toast></p-toast>

<div [ngClass]="{'sidebar-active': app.sidebarActive}" class="flex">
    <div class="sidebar-next-right-block">
        <div class="flex flex-row">
            <div class="col-2 w-18">
                <sidebar-menu>
                    <div class="sidebar-body">
                        <div class="onboarding-slider-menu" id="onboarding-slider-menu">
                            <ul class="onboarding-slider-menu__list onboarding-slider-menu__list--theme-calypso" data-slider-menu="list">
                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.StoreCreation}}">
                                    <a (click)="clickMenuLink(merchantStatusEnum.StoreCreation)" class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso">{{(!isMerchant) ? 'Stores' : 'Stores'}}</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.CreatedStore}}">
                                    <a (click)="clickMenuLink(merchantStatusEnum.CreatedStore)" class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso">{{(!isMerchant) ? 'Products' : 'Add your products'}}</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.AddedProducts}}">
                                    <a (click)="clickMenuLink(merchantStatusEnum.AddedProducts)" class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso">{{(!isMerchant) ? 'Employees' : 'Add an employee'}}</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.AddedEmployees}}">
                                    <a (click)="clickMenuLink(merchantStatusEnum.AddedEmployees)" class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso">{{(!isMerchant) ? 'Payment details' : 'Add payment details'}}</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.AddedPayment}}">
                                    <a (click)="clickMenuLink(merchantStatusEnum.AddedPayment)" class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso">{{(!isMerchant) ? 'Activation' : 'Review & Go Live!'}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </sidebar-menu>
            </div>

            <div class="merchant-onboarding-store-body col-10" [ngClass]="{
                        'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
                        'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
                        'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
                <div *ngIf="loading" style="text-align: center; padding: 30px;">
                    <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                                       fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
                </div>
                
                <div class="flex-row">
                    <div class="col-6 p-0" *ngIf="activeMerchantStatus !== merchantStatusEnum.StoreCreation">
                        <button mat-button class="mat-square-button" color="primary" (click)="onBackClick()">
                            <b><i class="pi pi-arrow-left"></i> Back</b>
                        </button>
                    </div>
                    <div class="col-6 p-0 text-end" *ngIf="(activeMerchantStatus === merchantStatusEnum.AddedEmployees && showMerchantPaymentGrid) || (showMerchantEmployees && activeMerchantStatus === merchantStatusEnum.AddedProducts)">
                        <button mat-raised-button class="text-white" color="primary" (click)="changeMerchantStoreStatus(activeMerchantStatus + 1)">
                            <b>Next <i class="pi pi-arrow-right"></i></b>
                        </button>
                    </div>
                </div>

                <div *ngIf="!showMerchantPaymentGrid && !showMerchantEmployees && ![merchantStatusEnum.StoreCreation,merchantStatusEnum.AddedPayment].includes(activeMerchantStatus)" class="global-store-header mb-3">
                    Create your store
                </div>

                <create-store-container 
                    *ngIf="activeMerchantStatus === merchantStatusEnum.StoreCreation
                    && !loading" 
                    [stores]="stores"
                    (nextStep)="changeMerchantStoreStatus(merchantStatusEnum.CreatedStore)"
                >
                    <div class="global-store-header mb-3" header>
                        Create your store
                    </div>
                </create-store-container>

                <merchant-edit-product [_showMerchantEditProductSideBar]="showMerchantEditProductSideBar"
                                       [_productId]="productId"
                                       [merchantStoreOnboardingComponent]="this"
                                       (changedShowMerchantEditProductSideBarEmit)="changedShowMerchantEditProductSideBarEmit($event)"
                                       *ngIf="activeMerchantStatus === merchantStatusEnum.CreatedStore && showMerchantEditProductSideBar"></merchant-edit-product>

                <merchant-approved-reject-product [_showMerchantApprovedRejectProductSideBar]="showMerchantApprovedRejectProductSideBar"
                                                  [_productId]="productId" [_merchantId]="merchantId"
                                                  [merchantStoreOnboardingComponent]="this"
                                                  (changedShowMerchantApprovedRejectProductSideBarEmit)="changedShowMerchantApprovedRejectProductSideBarEmit($event)"
                                                  *ngIf="activeMerchantStatus === merchantStatusEnum.CreatedStore && showMerchantApprovedRejectProductSideBar && !isMerchant"></merchant-approved-reject-product>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.CreatedStore && !showMerchantProductsTable && !loading">
                    <div class="mob-height">
                        <img class="mos-bg-img-block product-img-bg" src="/XpressApp/assets/images/product/product.svg" />
                        <p-scrollPanel [style]="{height: 'calc(75vh)'}">
                            <div class="mos-header">
                                <div class="mos-header__title">Products</div>
                            </div>
                            <div class="mos-description">
                                Time to showcase what you offer! Add your products or 
                                menu items, set prices, and organize everything into
                                categories. Don't forget to add appealing descriptions and 
                                mark your bestsellers.
                            </div>
                            <div class="mt-4">
                                <button mat-raised-button color="primary" (click)="onShowProductTable()">Add Products</button>
                            </div>
                        </p-scrollPanel>
                    </div>
                </div>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.CreatedStore && showMerchantProductsTable && !loading">
                    <div class="merchant-onboarding-store-products-body">
                        <merchant-products (changedProductsCountEmit)="changedProductsCount($event)"></merchant-products>
                    </div>
                    <div class="merchant-onboarding-store-footer" *ngIf="activeMerchantStatus === merchantStatusEnum.CreatedStore && showMerchantProductsTable && !loading">
                        <div class="flex justify-content-end">
                            <button class="bluedark-btn" pButton [disabled]="productsCount === 0"
                                    (click)="changeMerchantStoreStatus(merchantStatusEnum.AddedProducts)">
                                {{(!isMerchant) ? 'Next' : 'Confirm upload'}}
                            </button>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.AddedProducts">
                    <div class="mob-height" style="position: relative;" *ngIf="isMerchant && !showMerchantEmployees">
                        <merchant-create-employee (showMerchantEmployees)="addEmployee($event)"></merchant-create-employee>
                    </div>

                    <div class="merchant-onboarding-store-employee-body" style="position: relative;" *ngIf="!isMerchant || showMerchantEmployees">
                        <merchant-employees [merchantId]="merchantId"></merchant-employees>
                    </div>
                </div>

                <merchant-payment [merchantId]="merchantId"
                                  (showMerchantPaymentGrid)="showPaymentSetup($event)" 
                                  *ngIf="activeMerchantStatus === merchantStatusEnum.AddedEmployees && 
                                  !showMerchantPaymentGrid && 
                                  !loading"></merchant-payment>

                <merchant-payment-view [merchantId]="merchantId"
                                       (hidePaymentGridViewEmit)="hidePaymentGridView()"
                                       *ngIf="activeMerchantStatus === merchantStatusEnum.AddedEmployees &&
                                        showMerchantPaymentGrid &&
                                        !loading"></merchant-payment-view>

                <merchant-detail-payment [_showMerchantDetailPaymentSideBar]="showMerchantDetailPaymentSideBar"
                                         [_merchantId]="merchantId"
                                         [merchantStoreOnboardingComponent]="this"
                                         (changedShowMerchantDetailPaymentSideBarEmit)="changedShowMerchantDetailPaymentSideBarEmit($event)"
                                         *ngIf="showMerchantDetailPaymentSideBar"></merchant-detail-payment>

                <div *ngIf="isMerchant && activeMerchantStatus === merchantStatusEnum.AddedPayment">
                    <div class="mob-height" *ngIf="!isReview">
                        <img class="mos-bg-img-block review-img-bg" src="/XpressApp/assets/images/merchant/activationreview.svg" />
                         <merchant-activation></merchant-activation>
                      
                    </div>

                    <merchant-detail-product [_showMerchantDetailProductSideBar]="showMerchantDetailProductSideBar"
                                             [_productId]="productId"
                                             [merchantStoreOnboardingComponent]="this"
                                             (changedShowMerchantDetailProductSideBarEmit)="changedShowMerchantDetailProductSideBarEmit($event)"
                                             *ngIf="showMerchantDetailProductSideBar"></merchant-detail-product>

                    <div *ngIf="isReview" style="padding: 0;">
                        <p-scrollPanel [style]="{height: 'calc(75vh)'}">
                            <div class="cs-review-header-block">
                                <div class="flex flex-row">
                                    <div class="cs-review-header__menu-link"
                                         [ngClass]="{'menu-link-active': activeReviewMenuEnum === reviewMenuEnum.Store}"
                                         (click)="changeReviewMenu(reviewMenuEnum.Store)">Store</div>
                                    <div class="cs-review-header__menu-link"
                                         [ngClass]="{'menu-link-active': activeReviewMenuEnum === reviewMenuEnum.Products}"
                                         (click)="changeReviewMenu(reviewMenuEnum.Products)">Products</div>
                                    <div class="cs-review-header__menu-link"
                                         [ngClass]="{'menu-link-active': activeReviewMenuEnum === reviewMenuEnum.Employee}"
                                         (click)="changeReviewMenu(reviewMenuEnum.Employee)">Employee</div>
                                    <div class="cs-review-header__menu-link"
                                         [ngClass]="{'menu-link-active': activeReviewMenuEnum === reviewMenuEnum.Payment}"
                                         (click)="changeReviewMenu(reviewMenuEnum.Payment)">Payment</div>
                                    <div class="cs-review-header__menu-link"
                                         [ngClass]="{'menu-link-active': activeReviewMenuEnum === reviewMenuEnum.Submit}"
                                         (click)="changeReviewMenu(reviewMenuEnum.Submit)">Submit</div>
                                </div>
                            </div>
                            <div *ngIf="activeReviewMenuEnum === reviewMenuEnum.Store">
                                <div class="cs-review-body-block">
                                    <div class="cs-review-flex-container">
                                        <div class="cs-review-store-item" *ngFor="let store of stores"
                                             (click)="openMerchantStoreDetailSideBar(store.Id)">
                                            <div class="flex flex-row">
                                                <div class="cs-review-store-column40">
                                                    <div class="cs-review-store-response">
                                                        <img class="cs-review-store-img" src="{{store.ImageUrl}}" />
                                                    </div>
                                                </div>
                                                <div class="cs-review-store-column60">
                                                    <div class="cs-review-store-title">{{store.Name}}</div>
                                                    <div class="cs-review-store-desc">{{store.Address}} <br /> {{store.AddressDetails}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="activeReviewMenuEnum === reviewMenuEnum.Products">
                                <div class="cs-review-body-block">
                                    <div class="cs-review-flex-container">
                                        <div class="cs-review-store-item" *ngFor="let product of products"
                                             (click)="openMerchantDetailProductSideBar(product.Id)">
                                            <div class="flex flex-row">
                                                <div class="cs-review-store-column40">
                                                    <div class="cs-review-store-response">
                                                        <img class="cs-review-store-img" src="{{product.ImageUrl}}" />
                                                    </div>
                                                </div>
                                                <div class="cs-review-store-column60">
                                                    <div class="cs-review-store-title">{{product.Name}}</div>
                                                    <div class="cs-review-store-subtitle">{{product.UnitText}}</div>
                                                    <div class="cs-review-store-desc">{{product.Description}}</div>
                                                    <div class="cs-review-store-price">{{product.PublishedPrice}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="activeReviewMenuEnum === reviewMenuEnum.Employee">
                                <div style="padding: 20px;">
                                    <merchant-employees [merchantId]="merchantId" [reviewEmployee]="true"
                                                        *ngIf="isMerchant && activeReviewMenuEnum === reviewMenuEnum.Employee"></merchant-employees>
                                </div>
                            </div>
                            <div *ngIf="activeReviewMenuEnum === reviewMenuEnum.Payment">
                                <div class="cs-review-body-block">
                                    <div class="cs-review-flex-container">
                                        <div class="cs-review-store-item" *ngFor="let payment of payments">
                                            <div class="mos-btn-rounded-block">
                                                <p-button icon="pi pi-ellipsis-v" styleClass="p-button-rounded p-button-text" (click)="op.toggle($event)"></p-button>
                                                <p-overlayPanel #op [style]="{width: '130px'}">
                                                    <ng-template pTemplate>
                                                        <div class="mos-op-link" (click)="openMerchantAddPaymentSideBar(payment)">Edit</div>
                                                        <div class="mos-op-link" (click)="openMerchantDetailPaymentSideBar()">Detail</div>
                                                    </ng-template>
                                                </p-overlayPanel>
                                            </div>
                                            <div class="flex flex-row">
                                                <div class="cs-review-store-column40">
                                                    <div class="cs-review-store-response">
                                                    </div>
                                                </div>
                                                <div class="cs-review-store-column60">
                                                    <div class="cs-review-store-title" (click)="openMerchantDetailPaymentSideBar()">{{payment.AccountName}}</div>
                                                    <div class="cs-review-store-desc" (click)="openMerchantDetailPaymentSideBar()">Account number: {{payment.AccountNumber}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="activeReviewMenuEnum === reviewMenuEnum.Submit">
                                <div class="review-submit-body">
                                    <p-scrollPanel [style]="{height: 'calc(75vh)'}">
                                        <div class="mos-header">
                                            <div class="mos-header__title">Complete store</div>
                                        </div>
                                        <div class="mos-description">
                                            If you're ready to complete your store, press proceed below.
                                            <br />
                                            Xpress will review your store and send live on the date you have selected below
                                        </div>
                                        <div class="mos-btn-block">
                                            <div class="mos-btn-block__label">When do you want your store to be live on Xpress</div>
                                            <div style="width: 200px;">
                                                <p-calendar inputId="basic" placeholder="Type here" [(ngModel)]="dateActivatedAt"></p-calendar>
                                            </div>
                                        </div>
                                    </p-scrollPanel>
                                </div>
                            </div>
                        </p-scrollPanel>
                    </div>
                    <div class="merchant-onboarding-store-footer" *ngIf="isReview">
                        <div class="flex justify-content-end">
                            <button class="bluedark-btn" pButton label="Submit"
                                    *ngIf="activeReviewMenuEnum !== reviewMenuEnum.Submit"
                                    (click)="changeReviewMenu(reviewMenuEnum.Submit)"></button>

                            <button class="green-btn" pButton label="Submit"
                                    *ngIf="activeReviewMenuEnum === reviewMenuEnum.Submit &&
                            isMerchant && activeMerchantStatus === merchanUser.StoreStatusId"
                                    (click)="changeMerchantStoreStatus(merchantStatusEnum.FinalReview)"></button>
                        </div>
                    </div>
                </div>

                <div *ngIf="!isMerchant && activeMerchantStatus === merchantStatusEnum.AddedPayment">
                    <div>
                        <img class="mos-bg-img-block" style="bottom: 0; right: 0;" src="/XpressApp/assets/images/merchant/activation.svg" />
                        <p-scrollPanel [style]="{height: 'calc(75vh)'}">
                            <div class="mos-header">
                                <div class="mos-header__title">Approvw & Activate</div>
                                <div class="mos-header__subtitle">Are these details correct?</div>
                            </div>
                            <hr />
                            <div class="flex flex-row">
                                <div class="store-activate-title">Customer has request activation: </div>
                                <div>
                                    <p-calendar inputId="basic" placeholder="Immediately!" [(ngModel)]="dateActivatedAt"></p-calendar>
                                </div>
                            </div>
                            <div class="store-following-block">
                                <div class="store-following-label">The customer has the following promotions</div>
                                <div class="store-following-text">- Free commision 30 days</div>
                            </div>
                            <div class="store-following-block">
                                <div class="store-following-label">The customer has the following ad credits</div>
                                <div class="store-following-text">None</div>
                            </div>
                            <div class="store-notifiy-email-block">
                                <div class="store-notifiy-email-info">
                                    By activating this store, the partner will receive a email notification
                                    <br />
                                    Xpress Account Manager & Xpress Marketing will also be notification via email
                                    <br />
                                    If you would like to notify anyone else, please add email below
                                </div>
                                <div class="store-notifiy-email-address">
                                    <input type="text" pInputText placeholder="Enter email address" [(ngModel)]="otherEmail">
                                </div>
                            </div>
                            <div class="mos-description">

                            </div>
                            <div class="mos-btn-block">
                                <div class="flex flex-row" *ngIf="!loading">
                                    <button class="outlined-red-btn" pButton label="Cancel" style="margin-right: 20px;" (click)="cancel()"></button>
                                    <button class="bluedark-btn" pButton label="Confirm" (click)="confirmMerchantStoreStatus()"></button>
                                </div>
                                <div *ngIf="loading" style="text-align: center; padding: 30px;">
                                    <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                                                       fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
                                </div>
                            </div>
                        </p-scrollPanel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
